import Icon from '../components/Icon.vue'

Icon.register({
  university: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 128V144A8-8 0 0 0 488 152H464V164C464 170.6 458.6 176 452 176H60C53.4 176 48 170.6 48 164V152H24A8-8 0 0 0 16 144V128A8-8 0 0 0 20.9 120.6L252.9 32.6A8-8 0 0 0 259.1 32.6L491.1 120.6A8-8 0 0 0 496 128zM472 432H40C26.7 432 16 442.7 16 456V472A8-8 0 0 1 24 480H488A8-8 0 0 1 496 472V456C496 442.7 485.3 432 472 432zM96 192V384H60C53.4 384 48 389.4 48 396V416H464V396C464 389.4 458.6 384 452 384H416V192H352V384H288V192H224V384H160V192H96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/university.js
// module id = V7q9
// module chunks = 144